import { render, staticRenderFns } from "./create-company.component.html?vue&type=template&id=2b63774d&scoped=true&external"
import script from "./create-company.component.ts?vue&type=script&lang=ts&external"
export * from "./create-company.component.ts?vue&type=script&lang=ts&external"
import style0 from "./create-company.component.scss?vue&type=style&index=0&id=2b63774d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63774d",
  null
  
)

export default component.exports